import {Component, inject} from '@angular/core'
import {UserService} from '../../services/user.service'
import {RouterLink} from '@angular/router'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {MatIconButton} from '@angular/material/button'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../../../environments/environment'
import {ApplicationService} from '../../services/application.service'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    RouterLink,
    LogoComponent,
    ToggleButtonComponent,
    MatIconButton
  ]
})
export class HeaderComponent {
  public userService = inject(UserService)
  public applicationService = inject(ApplicationService)
  public developerMode = environment.developerMode
}
